export const ENGLISH_IQ_RETAKE_AFTER_DAYS = 30;
